<template>
  <el-dialog
    title="设置结算"
    width="1190px"
    :visible.sync="settlementVisible"
    :before-close="handleClose"
    :append-to-body="true"
    :destroy-on-close="true"
    class="theme-dialog dialog-center dialog-body-0 split-line-footer-dialog"
  >
    <div class="flex-box">
      <el-form
        :style="{ flex: 'auto', width: 'calc(100% - 230px)' }"
        style="border-right: 1px solid #e7e9eb"
        ref="taskForm"
        :model="baseInfo"
        label-width="110px"
        label-position="right"
      >
        <el-form-item
          :style="{ marginBottom: baseInfo.settleMode ? '0' : '18px' }"
          label="结算类型："
          prop="settleMethod"
          :rules="[{ required: true, message: ' ', trigger: 'change' }]"
        >
          <div class="flex">
            <div class="inline-block">
              <div
                class="btn-box btn1 box-border"
                :class="{ 'btn-checked': btnChecked == 'online' }"
                @click="changeSettleMethod('online')"
              >
                <el-checkbox class="position-checkbox" :disabled="!(btnChecked == 'online')" :value="true"></el-checkbox>
                <div>
                  <div class="text-theme-black-650 text-medium mb-2 font-semibold">
                    线上结算
                    <div class="tujian bg-yellow-theme text-white inline-block text-center font-semibold text-small">推荐</div>
                  </div>
                  <div class="text-theme-black-450 text-small">
                    线上支付调查员费用，调研工厂代调查员纳税，并为您的总花费开具发票
                  </div>
                  <div class="flex justify-between mt-1" v-if="!isOpen">
                    <span class="text-yellow-theme text-small">
                      <i class="iconfont icon-jingshishuoming text-small font-semibold"></i>
                      尚未开通，无法使用
                    </span>
                    <span class="cursor-pointer text-theme text-small" @click="toOpen">去开通></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="inline-block">
              <div
                class="btn-box btn2 box-border"
                :class="{ 'btn-checked': btnChecked == 'offline' }"
                @click="changeSettleMethod('offline')"
              >
                <el-checkbox class="position-checkbox" :disabled="!(btnChecked == 'offline')" :value="true"></el-checkbox>
                <div>
                  <div class="text-theme-black-650 text-medium mb-2 font-semibold">线下结算</div>
                  <div class="text-theme-black-450 text-small">常用场景：线下与调查员签署劳务协议、协商支付方式、纳税事宜等</div>
                </div>
              </div>
            </div>
            <div class="inline-block">
              <div
                class="btn-box btn2 box-border"
                :class="{ 'btn-checked': btnChecked == 'neednot' }"
                @click="changeSettleMethod('neednot')"
              >
                <el-checkbox class="position-checkbox" :disabled="!(btnChecked == 'neednot')" :value="true"></el-checkbox>
                <div>
                  <div class="text-theme-black-650 text-medium mb-2 font-semibold">无需结算</div>
                  <div class="text-theme-black-450 text-small">常用场景：已同调查员签署劳动合同或调查员愿提供无偿服务等</div>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item
          :style="{ marginBottom: baseInfo.settleMode ? '0' : '18px' }"
          label="结算方式："
          prop="settleMode"
          :rules="[{ required: true, message: ' ', trigger: 'change' }]"
        >
          <el-radio-group @change="changeRadio" v-model="baseInfo.settleMode" :disabled="!isOpen && baseInfo.settleMethod == 0">
            <el-radio :label="1">按答卷数量</el-radio>
            <el-radio :label="2">按天</el-radio>
            <el-radio v-if="!(btnChecked == 'neednot')" :label="3">按阶梯计价</el-radio>
          </el-radio-group>
        </el-form-item>

        <div class="settlementType-style" v-if="baseInfo.settleMode === 1">
          <div class="flex-box" v-if="baseInfo.settleMethod != 2">
            <el-form-item
              label="单价:"
              prop="settleRule.unitPriceYuan"
              :rules="[
                {
                  required: !((!isOpen && baseInfo.settleMethod == 0) || baseInfo.settleMethod == 2),
                  message: ' ',
                  trigger: 'change'
                }
              ]"
            >
              <el-input-number
                placeholder=""
                v-model="baseInfo.settleRule.unitPriceYuan"
                autocomplete="off"
                controls-position="right"
                :min="1"
                :max="Infinity"
                :precision="2"
                :disabled="(!isOpen && baseInfo.settleMethod == 0) || baseInfo.settleMethod == 2"
              >
              </el-input-number>
            </el-form-item>
            <span>元</span>
          </div>
          <div class="flex-box">
            <span class="pos-abs-box">
              <i>*</i>
              答卷数量:
              <el-tooltip
                effect="dark"
                content="该数量仅为参考回收数量，调查员可超额上报答卷，您可与调查员线下协商上报数量，采用线上结算时，可按照实际上报答卷数量进行结算"
                placement="top"
              >
                <div class="icon-wrap" style="margin-left: 4px">
                  <span class="icon-font ico-tips" style="font-size: 12px">&#xe65b;</span>
                </div>
              </el-tooltip>
            </span>
            <el-form-item
              label=""
              prop="settleRule.expectedQuantity"
              :rules="[{ required: !(!isOpen && baseInfo.settleMethod == 0), message: ' ', trigger: 'change' }]"
            >
              <el-input-number
                placeholder=""
                v-model="baseInfo.settleRule.expectedQuantity"
                autocomplete="off"
                controls-position="right"
                :min="1"
                :max="Infinity"
                :precision="0"
                :disabled="!isOpen && baseInfo.settleMethod == 0"
              >
              </el-input-number>
            </el-form-item>
            <span>份</span>
          </div>
          <div class="settlement-tips" style="margin-bottom: 0" v-if="baseInfo.settleMethod != 2">
            <div style="display: flex">
              <div>预估费用：{{ totalPriceYuan }}元，若采用线上结算，项目预计花费 {{ totalPriceYuan }}元</div>
              <el-tooltip
                effect="dark"
                :content="`项目预计费用=预估费用*（1+${accRate}），其中${accountingRateVal}为用于调查员待缴税及平台技术服务费`"
                placement="top"
              >
                <div class="icon-wrap" style="margin-left: 4px">
                  <span class="icon-font ico-tips" style="font-size: 12px">&#xe65b;</span>
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div class="settlementType-style" v-if="baseInfo.settleMode === 2">
          <div class="flex-box" v-if="baseInfo.settleMethod != 2">
            <el-form-item
              label="单价:"
              prop="settleRule.unitPriceYuan"
              :rules="[
                {
                  required: !((!isOpen && baseInfo.settleMethod == 0) || baseInfo.settleMethod == 2),
                  message: ' ',
                  trigger: 'change'
                }
              ]"
            >
              <el-input-number
                placeholder=""
                v-model.number="baseInfo.settleRule.unitPriceYuan"
                autocomplete="off"
                controls-position="right"
                :min="1"
                :max="Infinity"
                :precision="2"
                :disabled="(!isOpen && baseInfo.settleMethod == 0) || baseInfo.settleMethod == 2"
              >
              </el-input-number>
            </el-form-item>
            <span>元</span>
          </div>
          <div class="flex-box" style="position: relative">
            <span class="pos-abs-box">
              <i>*</i>
              天数:
              <el-tooltip
                effect="dark"
                content="当天只要上报答卷即记为工作 1 天，该天数仅为参考工作天数，您可与调查员线下协商工作天数，采用线上结算时，可按照实际工作天数进行结算"
                placement="top"
              >
                <div class="icon-wrap" style="margin-left: 4px">
                  <span class="icon-font ico-tips" style="font-size: 12px">&#xe65b;</span>
                </div>
              </el-tooltip>
            </span>
            <el-form-item
              label=""
              prop="settleRule.expectedQuantity"
              :rules="[{ required: !(!isOpen && baseInfo.settleMethod == 0), message: ' ', trigger: 'change' }]"
            >
              <el-input-number
                placeholder=""
                v-model.number="baseInfo.settleRule.expectedQuantity"
                autocomplete="off"
                controls-position="right"
                :min="1"
                :max="Infinity"
                :precision="0"
                :disabled="!isOpen && baseInfo.settleMethod == 0"
              >
              </el-input-number>
            </el-form-item>
            <span>天</span>
          </div>
          <div class="settlement-tips" style="margin-bottom: 0" v-if="baseInfo.settleMethod != 2">
            <div style="display: flex">
              <div>预估费用：{{ totalPriceYuan }}元，若采用线上结算，项目预计花费 {{ totalPriceYuan }}元</div>
              <el-tooltip
                effect="dark"
                :content="`项目预计费用=预估费用*（1+${accRate}），其中${accountingRateVal}为用于调查员待缴税及平台技术服务费`"
                placement="top"
              >
                <div class="icon-wrap">
                  <span class="icon-font ico-tips">&#xe65b;</span>
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div class="settlementType-style" style="padding: 12px 4px" v-if="baseInfo.settleMode === 3">
          <el-form-item class="is-require-task" style="margin-bottom: 8px" label="单价:" v-if="baseInfo.settleMethod != 2">
            <span style="margin-right: 8px">每天</span>
            <div
              class="flex-settlement"
              v-for="(item, index) in baseInfo.settleRule.tiers"
              :key="index"
              :style="{ marginBottom: index === baseInfo.settleRule.tiers.length - 1 ? '0px' : '5px' }"
            >
              <el-form-item label>
                <el-input-number
                  v-if="index === 0"
                  :disabled="true"
                  placeholder=""
                  v-model="item.quantityLowerBound"
                  autocomplete="off"
                  controls-position="right"
                  :min="0"
                  :max="Infinity"
                  :precision="0"
                >
                </el-input-number>
                <el-input-number
                  v-if="index > 0"
                  :disabled="true"
                  placeholder=""
                  :value="baseInfo.settleRule.tiers[index - 1].quantityUpperBound"
                  autocomplete="off"
                  controls-position="right"
                  :min="0"
                  :max="Infinity"
                  :precision="0"
                >
                </el-input-number>
              </el-form-item>
              <span style="margin: 0 8px">份 &lt; 完成量 ≤</span>
              <el-form-item
                label
                :prop="'settleRule.tiers[' + index + '].quantityUpperBound'"
                :rules="[
                  {
                    required: !((!isOpen && baseInfo.settleMethod == 0) || baseInfo.settleMethod == 2),
                    message: ' ',
                    trigger: 'change'
                  }
                ]"
              >
                <el-input-number
                  placeholder=""
                  v-model="item.quantityUpperBound"
                  autocomplete="off"
                  controls-position="right"
                  :min="index > 0 ? baseInfo.settleRule.tiers[index - 1].quantityUpperBound * 1 + 1 : 1"
                  :max="Infinity"
                  @change="val => currentInputNumber(val, item, index)"
                  :precision="0"
                  :disabled="(!isOpen && baseInfo.settleMethod == 0) || baseInfo.settleMethod == 2"
                >
                </el-input-number>
              </el-form-item>
              <span style="margin: 0 8px">份，按完成量</span>
              <el-form-item
                label
                :prop="'settleRule.tiers[' + index + '].unitPriceYuan'"
                :rules="[
                  {
                    required: !((!isOpen && baseInfo.settleMethod == 0) || baseInfo.settleMethod == 2),
                    message: ' ',
                    trigger: 'change'
                  }
                ]"
                style="margin-left: 10px"
              >
                <el-input-number
                  placeholder=""
                  v-model.number="item.unitPriceYuan"
                  autocomplete="off"
                  controls-position="right"
                  :min="1"
                  :max="Infinity"
                  :precision="2"
                  :disabled="(!isOpen && baseInfo.settleMethod == 0) || baseInfo.settleMethod == 2"
                >
                </el-input-number>
              </el-form-item>
              <span style="margin-left: 8px">元/份</span>
              <el-button v-if="index === 0" @click="handleSettlement('add', index)" class="btn-style" type="text"
                ><i class="icon-font">&#xe68c;</i></el-button
              >
              <el-button
                v-else-if="index === baseInfo.settleRule.tiers.length - 1"
                @click="handleSettlement('remove', index)"
                class="btn-style"
                type="text"
                ><i class="icon-font">&#xe68a;</i></el-button
              >
              <!-- <el-button @click="handleSettlement(index=== baseInfo.ladderSettlement.length-1 ? 'add' : 'remove')" class="btn-style" type="text"> {{index=== 0? '+':'-'}}</el-button> -->
            </div>
          </el-form-item>
          <div class="flex-box">
            <el-form-item
              style="margin-bottom: 0"
              label="天数:"
              prop="settleRule.expectedQuantity"
              :rules="[{ required: !(!isOpen && baseInfo.settleMethod == 0), message: ' ', trigger: 'change' }]"
            >
              <el-input-number
                placeholder=""
                v-model.number="baseInfo.settleRule.expectedQuantity"
                autocomplete="off"
                controls-position="right"
                :min="1"
                :max="Infinity"
                :precision="0"
                :disabled="!isOpen && baseInfo.settleMethod == 0"
              >
              </el-input-number>
            </el-form-item>
            <span>天</span>
          </div>
        </div>
      </el-form>
      <div class="right-counter" :style="{ width: '290px', flex: 'none', overflow: 'auto', height: '500px' }">
        <Advert></Advert>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="$emit('closeDialog')">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" size="mini">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import AccountCalculator from '@/components/base/AccountCalculator.vue'
import store from '@/store'
import Advert from '@/components/interview/advert/index.vue'

export default {
  props: ['settlementVisible'],
  components: { AccountCalculator, Advert },
  data() {
    return {
      isOpen: false,
      data: '123',
      btnChecked: 'online',
      settleMethodMap: {
        online: 0,
        offline: 1,
        neednot: 2
      },
      // dialogTableVisible:true,
      baseInfo: {
        settleMethod: 0,
        settleMode: 1,
        settleRule: {
          unitPriceYuan: undefined, //单价 多少元/天  多少元/份
          expectedQuantity: undefined, // 数量 多少份 | 多少天
          tiers: [
            {
              quantityLowerBound: 0,
              quantityUpperBound: undefined,
              unitPriceYuan: undefined
            }
          ]
        }
      }
    }
  },
  watch: {
    settlementVisible: function (val) {
      if (val === true) {
        console.log(123)
        this.btnChecked = 'online'
        this.baseInfo = {
          settleMethod: 0,
          settleMode: 1,
          settleRule: {
            unitPriceYuan: undefined, //单价 多少元/天  多少元/份
            expectedQuantity: undefined, // 数量 多少份 | 多少天
            tiers: [
              {
                quantityLowerBound: 0,
                quantityUpperBound: undefined,
                unitPriceYuan: undefined
              }
            ]
          }
        }
        if(this.$refs.taskForm){
          this.$refs.taskForm.resetFields();
        }
      }
    }
  },
  computed: {
    totalPriceYuan() {
      if (this.baseInfo.settleRule.expectedQuantity && this.baseInfo.settleRule.unitPriceYuan) {
        return (this.baseInfo.settleRule.expectedQuantity * this.baseInfo.settleRule.unitPriceYuan).toFixed(2)
      } else {
        return 0
      }
    },
    totalSaleYuan() {
      if (this.baseInfo.settleRule.expectedQuantity && this.baseInfo.settleRule.unitPriceYuan) {
        return ((1 + this.accRate * 1) * (this.baseInfo.settleRule.expectedQuantity * this.baseInfo.settleRule.unitPriceYuan)).toFixed(2)
      } else {
        return 0
      }
    },
    accountingRateVal() {
      const { accountingRate = 0 } = this.$store.getters || {};
      return accountingRate === null || accountingRate === 0 ? '6.5%' : `${accountingRate}%`
    },
    accRate() {
      const { accountingRate = 0 } = this.$store.getters || {};
      return accountingRate === null || accountingRate === 0 ? '0.065' : (accountingRate / 100).toFixed(3)
    }
  },
  methods: {
    toOpen() {
      window.open(
        `${window.location.origin + process.env.VUE_APP_PRE_URL}/#/cost-settlement`
      )
    },
    changeSettleMethod(btnType) {
      this.btnChecked = btnType
      this.baseInfo.settleMethod = this.settleMethodMap[btnType]
      this.changeRadio(1)
    },
    handleClose() {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.$emit('closeDialog')
        })
        .catch(_ => {})
    },
    changeRadio(val) {
      console.log(val)
      let sm = this.baseInfo.settleMethod
      this.baseInfo = {
        settleMethod: sm,
        settleMode: val,
        settleRule: {
          unitPriceYuan: undefined, //单价 多少元/天  多少元/份
          expectedQuantity: undefined, // 数量 多少份 | 多少天
          tiers: [
            {
              quantityLowerBound: 0,
              quantityUpperBound: undefined,
              unitPriceYuan: undefined
            }
          ]
        }
      }
    },
    // 监听input-number值的变化
    currentInputNumber(val, item, currentIndex) {
      const baseSettleRule = JSON.parse(JSON.stringify(this.baseInfo.settleRule))
      baseSettleRule.tiers.forEach((it, i, arr) => {
        if (i > currentIndex) {
          it.quantityUpperBound = arr[i - 1].quantityUpperBound + 1
        }
      })
      // this.baseInfo.settleRule = baseSettleRule;
      this.baseInfo.settleRule = {
        ...this.baseInfo.settleRule,
        tiers: baseSettleRule.tiers
      }
    },
    handleSettlement(type, index) {
      console.log(type)
      if (type === 'add') {
        const validateArr = []
        this.baseInfo.settleRule.tiers.forEach((it, i) => {
          validateArr.push(`settleRule.tiers[${i}].quantityUpperBound`)
          validateArr.push(`settleRule.tiers[${i}].unitPriceYuan`)
        })
        let validFlag = false
        validateArr.forEach(item => {
          this.$refs['taskForm'].validateField(
            validateArr,
            valid => (validFlag = valid ? false : true) // 定义是否通过表单验证
          )
        })
        console.log('validateArr:', validateArr)
        if (validFlag) {
          if (this.baseInfo.settleRule.tiers.length < 5) {
            const lastTiers = this.baseInfo.settleRule.tiers[this.baseInfo.settleRule.tiers.length - 1]
            const lastObj = { quantityUpperBound: lastTiers.quantityUpperBound, unitPriceYuan: lastTiers.unitPriceYuan }

            const flagDouble = Object.values(lastObj).includes(undefined)
            if (flagDouble) {
              this.$message.error('请完善表单项')
              return
            }
            const cloneLadderSettlement = this.baseInfo.settleRule.tiers
            cloneLadderSettlement.push({
              quantityLowerBound: undefined,
              quantityUpperBound: undefined,
              unitPriceYuan: undefined
            })
            this.baseInfo.settleRule.tiers = cloneLadderSettlement
          } else {
            this.$message.error('最多只能添加5条数据')
          }
        } else {
          this.$message.error('请完善表单项')
        }
      } else if (type === 'remove') {
        const cloneLadderSettlement = this.baseInfo.settleRule.tiers

        this.baseInfo.settleRule.tiers = cloneLadderSettlement.filter((it, i) => index !== i)
      }
    },
    handleSubmit() {
      if (!this.isOpen && this.baseInfo.settleMethod == 0) {
        this.$message({
          message: '尚未开通费用结算，无法设定线上结算',
          type: 'warning'
        })
        return
      }
      this.$refs['taskForm'].validate(valid => {
        if (valid || this.baseInfo.settleMethod == 2) {
          let postData = {}
          if (this.baseInfo.settleMode === 3) {
            const cloneLadderSettlement = [...this.baseInfo.settleRule.tiers]
            cloneLadderSettlement.forEach((it, i, arr) => {
              if (i > 0) {
                it.quantityLowerBound = arr[i - 1].quantityUpperBound * 1
              }
            })
            postData = {
              ...this.baseInfo,
              settleRule: {
                ...this.baseInfo.settleRule,
                tiers: cloneLadderSettlement
              }
            }
            // postData.ladderSettlement =cloneLadderSettlement;
          } else {
            postData = { ...this.baseInfo }
          }
          console.log('postData:', postData)
          this.$emit('settleData', postData)
        } else {
          this.$message.error('请将必填项填写完整！')
          console.log('error submit!!', valid)
          return false
        }
      })
    }
  },
  mounted() {
    this.isOpen = store.getters.settlementType !== 1
  }
}
</script>
<style lang="scss">
.flex-box {
  display: flex;
  .pos-abs-box {
    position: absolute;
    display: flex;
    justify-content: flex-end;
    width: 98px;
    padding-right: 12px;
    i {
      content: '*';
      color: #e34152;
      margin-right: 4px;
    }
  }
  .el-form {
    //flex:'auto';
    padding: 24px;
  }
  .right-counter {
    //width: 269px;
    //height: 228px;
    // .pl-6 {
    //   padding-left: 16px;
    // }
    .border-theme-gray {
      border: none;
    }
  }
  .icon-wrap {
    margin-left: 10px;
    .ico-tips {
      color: rgba(0,0,0,0.35);
    }
  }
}
</style>
<style lang="scss" scoped>
.btn-box {
  @apply flex justify-center;
  padding: 10px;
  min-height: 106px;
  width: 220px;
  border-radius: 2px;
  cursor: pointer;
  line-height: 16px;
  position: relative;
  .position-checkbox {
    position: absolute;
    right: 0;
    top: -2px;
  }
  &.btn1 {
    border: 1px solid #cccccc;
  }
  &.btn2 {
    border: 1px solid #cccccc;
    margin-left: 12px;
  }
  &.btn1.btn-checked,
  &.btn2.btn-checked {
    background: rgba(39, 117, 232, 0.1);
    border: 1px solid var(--theme-color) !important;
  }
  .tujian {
    border: 1px solid #faad14;
    border-radius: 8px;
    width: 34px;
    height: 16px;
    font-weight: 500;
    font-size: 12px;
  }
}
// .btn-checked div {
//   div {
//     color: #2775e8 !important;
//   }
//   i {
//     color: #2775e8 !important;
//   }
// }
.btn-box:hover {
  &.btn1,
  &.btn2 {
    background: rgba(39, 117, 232, 0.1);
    border: 1px solid var(--theme-color) !important;
    // div {
    //   div {
    //     color: #2775e8 !important;
    //   }
    //   i {
    //     color: #2775e8 !important;
    //   }
    // }
  }
}
</style>
